import { apiClientWithMiddleware } from '../../../utils/API';
import { getPortalId } from '../../../utils/getPortalId';
const TRIAL_BANNER_API_URL = 'growth-modals/v1/banner';
export const getHasTrialBanners = () => {
  const portalId = getPortalId();
  return apiClientWithMiddleware().get(`${TRIAL_BANNER_API_URL}?portalId=${portalId}`).then(trialBanner => {
    return Object.keys(trialBanner).length > 0;
  }).catch(error => {
    if (error.status === 404) {
      return false;
    }
    throw error;
  });
};